//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        change (e) {
            const { index } = e.currentTarget.dataset
            console.log(index)
            this.$emit('change', index)
        }
    },
    props: {
        index: {
            type: [String, Number]
        },
        tabs: {
            type: Array
        }
    }
}
